import React from "react";
import Link from "components/base/Link";
import cn from "classnames";
import { ILegalSection } from "pages/legal/[slug]";

type Props = {
    current: string;
    items: ILegalSection[]
};

function LegalSidebar(props: Props) {
    const sidebarItemCn = cn(
        'block font-medium text-lg mb-2 hover:text-purple mr-6 px-4 py-3 rounded-lg',
        'hover:bg-purple-tint-light'
    );
    const activeCn = cn(
        'bg-purple-tint-light text-purple'
    );

    return (
        <div className={'w-96 mr-10 border-solid border-r border-purple-tint'}>
            {props.items.map(item => (
                <Link key={item.id} to={item.slug}>
                    <span className={`${sidebarItemCn} ${props.current == item.title ? activeCn : ''}`}>{item.shortTitle}</span>
                </Link>
            ))}
        </div>
    );
}

export default LegalSidebar;